export function getOAuthRedirectUrl(origin: string) {
  return new URL("/", origin).toString();
}
